import { Modal, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { isLocaleEnglish } from 'utils';
import enMedicalCard from '../../../assets/images/en-medical-card.png';
import zhMedicalCard from '../../../assets/images/zh-medical-card.png';

interface PolicyAndMemberIdModalProps {
  isModalVisible: boolean;
  handleModalClose: () => void;
}

function PolicyAndMemberIdModal(props: PolicyAndMemberIdModalProps) {
  const { t, i18n } = useTranslation();

  return (
    <Modal
      title={t('forgetLoginId.infoTitle')}
      open={props.isModalVisible}
      footer={null}
      onCancel={props.handleModalClose}
      width={400}
    >
      <Space direction="vertical" align="center">
        <img
          src={isLocaleEnglish(i18n.language) ? enMedicalCard : zhMedicalCard}
          style={{ marginBottom: 16 }}
          width="300"
        />
        <Typography.Text>{t('forgetLoginId.modalMessage')}</Typography.Text>
      </Space>
    </Modal>
  );
}

export default PolicyAndMemberIdModal;
